export default {"width": 10, "height": 10}
